import Skeleton from '../presentational/skeleton';
import { Spinner } from '../presentational/spinner';

const SkeletonGuildRaidCompositionPage = () => {
  return (
    <div>
      <div style={{ marginTop: 24 }}>
        <Skeleton height={238} style={{ position: 'relative' }}>
          <Spinner inline />
        </Skeleton>

        <div>
          <Skeleton height={36} />
          <Skeleton variant="item" height={841} style={{ position: 'relative' }}>
            <Spinner inline />
          </Skeleton>
        </div>
      </div>
    </div>
  );
};

export default SkeletonGuildRaidCompositionPage;

